import { gql } from '@apollo/client'

export const BUSINESS_QUERY = gql`
    query businessBySlug ($slug: String!) {
        businessBySlug(slug: $slug) {
            id
            name
            slug
            useContactMeFormInstantReviews
            instantReviewFeedbackImgUrl
            businessFeatures {
              instantReviews
              instantReviewRating
              instantReviewComment
              instantReviewImageUpload
              instantReviewName
              instantReviewsAdBlock
            }
            loyaltyProgramSetting {
              id
              loyaltyProgramName
              defaultPointCount
            }
            instantReviewSocialMedia {
              id
              iconUrl
              name
              url
              position
            }  
        }
    }
`